import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Badge } from 'src/registry/ui/Badge';
import { ICON_MAP } from 'src/utils/constants';

const CloudUserBadge = () => {
    return (
        <Badge theme="blue">
            <FontAwesomeIcon icon={ICON_MAP.CLOUD} />
            Cloud
        </Badge>
    );
};

export default CloudUserBadge;
